/**
 *
 * Asynchronously loads the component for EventGroupStatistic
 *
 */

import loadable from '../../utils/loadable';

export default loadable(() => import('./index'));
